module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    Total inflation since fork and inflation rate.\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-inflation"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    The chart is composed of 256 chunks of data in the past 30 days. The inflation rate is therefore calculated over a 1/256 period in that timeframe. The total inflation is calculated over all data since the BCH fork.\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a3a6d42","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/inflation.vue
// module id = 527
// module chunks = 1